export default __webpack_public_path__ + "static/media/copy.848f3efb.svg";